import ArrepentimientoButton from "./ArrepentimientoButton";

const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_silicom-pro-futbol/artifacts/bsulykak_Untitled%20Project%20-%20Artboard%201%20%281%29%20%281%29%20%281%29.png";

const Footer = () => (
  <footer className="border-t border-slate-100 bg-white">
    <div className="mx-auto grid max-w-7xl gap-8 px-6 py-14 md:grid-cols-4">
      <div className="md:col-span-2">
        <img src={LOGO_URL} alt="Silicomlan" className="h-14 w-auto" />
        <p className="mt-4 max-w-sm text-sm text-slate-600">
          Internet por fibra óptica FTTH. Más de una década conectando hogares
          y empresas en Zona Oeste y Baradero, con soporte local y atención
          humana.
        </p>
        <div className="mt-6">
          <ArrepentimientoButton />
        </div>
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-pink-500">
          Enlaces
        </p>
        <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
          <li>
            <a href="#planes" className="hover:text-slate-900">
              Planes
            </a>
          </li>
          <li>
            <a href="#cobertura" className="hover:text-slate-900">
              Cobertura
            </a>
          </li>
          <li>
            <a href="#empresa" className="hover:text-slate-900">
              Empresa
            </a>
          </li>
          <li>
            <a href="#contacto" className="hover:text-slate-900">
              Contacto
            </a>
          </li>
          <li>
            <a
              href="/gaming"
              data-testid="footer-gaming-link"
              className="font-semibold text-pink-500 hover:text-pink-600"
            >
              Silicomlan Gaming
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-sky-500">
          Contacto
        </p>
        <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
          <li>0810-345-1201</li>
          <li>administracion@silicom.com.ar</li>
          <li>WhatsApp: 11-2779-0411</li>
          <li>
            <a
              href="https://instagram.com/silicom.com.ar"
              target="_blank"
              rel="noreferrer"
              className="hover:text-slate-900"
            >
              @silicom.com.ar
            </a>
          </li>
          <li>Leandro N. Alem 734, Merlo, BA</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-100 py-5 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} SilicomLan S.A. · Todos los derechos
      reservados · Fibra óptica local para Zona Oeste 🌸
    </div>
  </footer>
);

export default Footer;
